// extracted by mini-css-extract-plugin
export default {"deleteButton":"DeleteButton_deleteButton__FtX-p","modalConfirm":"DeleteButton_modalConfirm__-ACDl"};